module.exports = __webpack_public_path__ + "img/1-2.95ce497e.svg";